// extracted by mini-css-extract-plugin
export default {"root":"Question_root__ZyAao","body":"Question_body__Gkm6o","disabled":"Question_disabled__9Xsq4"};